import { SearchInput, ValidationProps, FormFieldsData, useInputHelper } from 'framework/form';
import useEmployeeNamesService from '../employeeNames/employeeNamesService';
import useEmployeeService from '../employeeService';

export const buildEmployeeAutoSuggestLabel = (employee: any) =>
  !!employee && `${employee.alias} ${employee.nameEn.firstName} ${employee.nameEn.lastName}`;

export interface EmployeeInputProps extends ValidationProps {
  source: string;
  label?: string;
  placeholder?: string;
  minSearchLength?: number;
  nameSource?: string;
  mapResults?: (employee: any) => void;
  defaultFilter?: Dictionary<object>;
  isVisible?: boolean | ((data: FormFieldsData) => boolean);
  disabled?: boolean | ((data: FormFieldsData) => boolean);
  props?: any;
  withContractors?: boolean;
  initialLabel?: string;
  onChangeCallback?: (values: FormFieldsData) => void;
  onInputChangeCallback?: (query: any) => void;
  valueDecorator?: (searchValue: string) => string;
  searchRequest?: (filter: any) => any;
  isInitialNameLoad?: boolean;
}

const EmployeeInput = ({
  mapResults,
  withContractors = true,
  isInitialNameLoad = false,
  ...props
}: EmployeeInputProps) => {
  const { getValue } = useInputHelper({ source: props.source });
  const { getEmployeeNameDataById } = useEmployeeNamesService();
  const { searchSuggestions, searchWithContractors } = useEmployeeService();

  const currentAlias = getValue();

  const mapResponse = (employee: any) => ({
    id: employee.alias,
    text: buildEmployeeAutoSuggestLabel(employee),
  });

  const searchMethod = withContractors ? searchWithContractors : searchSuggestions;

  const getInitValueName = async (): Promise<string> => {
    if (!currentAlias) return '';
    const employee = await getEmployeeNameDataById(currentAlias);

    return employee ? (buildEmployeeAutoSuggestLabel(employee) as string) : '';
  };

  return (
    <SearchInput
      searchRequest={searchMethod}
      noResultMessage="No Employees are found."
      mapResults={mapResults || mapResponse}
      customGetInitialValue={isInitialNameLoad && currentAlias ? getInitValueName : undefined}
      {...props}
    />
  );
};

export default EmployeeInput;
